/* Full-screen overlay nav for the Part O.T. Plan homepage. */
class PotpNav extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-nav-toggle]');
    this.menu = this.querySelector('[data-nav-menu]');
    if (!this.toggle || !this.menu) return;

    this.onToggle = () => this.setOpen(this.dataset.open !== 'true');
    this.onKey = (event) => {
      if (event.key === 'Escape' && this.dataset.open === 'true') {
        this.setOpen(false);
        this.toggle.focus();
      }
    };
    // Any menu link closes the overlay — in-page anchors wouldn't otherwise.
    this.onMenuClick = (event) => {
      if (event.target.closest('a')) this.setOpen(false);
    };

    this.toggle.addEventListener('click', this.onToggle);
    this.menu.addEventListener('click', this.onMenuClick);
    document.addEventListener('keydown', this.onKey);

    this.setOpen(false);
    this.watchCartCount();
  }

  // Dawn re-renders #cart-icon-bubble after an AJAX add. That element is hidden
  // here, so mirror the number it reports into our own styled badge.
  watchCartCount() {
    const source = this.querySelector('#cart-icon-bubble');
    const badge = this.querySelector('[data-cart-count]');
    if (!source || !badge) return;

    const sync = () => {
      const match = source.textContent.replace(/\s+/g, ' ').match(/\d+/);
      if (!match) return;
      const count = match[0];
      badge.textContent = count;
      badge.toggleAttribute('hidden', count === '0');
    };

    this.cartObserver = new MutationObserver(sync);
    this.cartObserver.observe(source, { childList: true, subtree: true, characterData: true });
  }

  disconnectedCallback() {
    if (this.cartObserver) this.cartObserver.disconnect();
    this.toggle.removeEventListener('click', this.onToggle);
    this.menu.removeEventListener('click', this.onMenuClick);
    document.removeEventListener('keydown', this.onKey);
    document.body.classList.remove('potp-menu-open');
  }

  setOpen(open) {
    this.dataset.open = open ? 'true' : 'false';
    this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    this.menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    this.toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    // Lock scroll behind the overlay, but not in the theme editor where the
    // section re-renders and could leave the body stuck.
    document.body.classList.toggle('potp-menu-open', open);
  }
}

customElements.define('potp-nav', PotpNav);
